class MCartRemoveButton extends HTMLElement {
    constructor() {
        super(), this.addEventListener("click", (t => {
            t.preventDefault();
            (this.closest("m-cart") || this.closest("m-cart-drawer-items")).updateQuantity(this.dataset.index, 0, null,t.target,t.target.dataset.itemKey)
        }))
    }
}
customElements.define("m-cart-remove-button", MCartRemoveButton);
class MCartTemplate extends HTMLElement {
    constructor() {
        super(), this.cartUpdateUnsubscriber = void 0, this.isCartPage = "cart" === MinimogSettings.templateName, this.cartDrawerWrapper = document.querySelector("m-cart-drawer"), this.cartDrawerInner = document.querySelector(".m-cart-drawer__inner"), this.mainCartItems = this.querySelector("[data-minimog-cart-items]"), this.cartSubTotal = this.querySelector("[data-cart-subtotal]"), this.cartDiscount = this.querySelector("[data-minimog-cart-discounts]"), this.giftWrapping = this.querySelector("[data-minimog-gift-wrapping]");
        let t = this.cartDrawerInner;
        this.isCartPage && (t = document.body), this.loading = new MinimogLibs.AnimateLoading(t, {
            overlay: t
        }), this.rootUrl = window.Shopify.routes.root;
        const e = debounce((t => {
            "id" !== t.target.name && this.onChange(t)
        }), 300);
        this.isCartPage ? this.mainCartItems.addEventListener("change", e.bind(this)) : this.addEventListener("change", e.bind(this)), MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (t => {
            this.getCart().then((t => {
                this.updateCartCount(t.item_count)
            }))
        }))
    }
    updateCartCount(t) {
        document.querySelectorAll(".m-cart-count-bubble").forEach((e => {
            t > 0 ? (e.textContent = t, e.classList.remove("m:hidden")) : e.classList.add("m:hidden")
        }))
    }
    getCart() {
        return fetchJSON(this.rootUrl + "cart.json")
    }
    connectedCallback() {
        this.cartUpdateUnsubscriber = MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (t => {
            "main-cart-items" !== t.source && this.onCartUpdate()
        }))
    }
    disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber()
    }
    onCartUpdate(t = !0) {
        const {
            routes: e
        } = window.MinimogSettings;
        fetch(`${e.cart}?section_id=cart-template`).then((t => t.text())).then((e => {
            const i = (new DOMParser).parseFromString(e, "text/html"),
                n = i.querySelector("[data-minimog-cart-items]"),
                r = i.querySelector("[data-cart-subtotal]"),
                a = i.querySelector("[data-minimog-cart-discounts]"),
                s = i.querySelector("[data-minimog-gift-wrapping]");
            this.isCartPage && (this.mainCartItems.innerHTML = n.innerHTML, t && (this.cartSubTotal.innerHTML = r.innerHTML, this.cartDiscount.innerHTML = a.innerHTML, this.giftWrapping.innerHTML = s.innerHTML))
        })).catch((t => {}))
    }
    onChange(t) {
        this.updateQuantity(t.target.dataset.index, t.target.value, document.activeElement.getAttribute("name"),t.target,t.target.dataset.itemKey)
    }
    updateQuantity(t, e, i,element,key) {
        this.loading.start();

        const updates = { [key]: e };
        const getSubKey = element.dataset.freeItems;
        if (getSubKey) {
          const subKeys = getSubKey.split(",").map(k => k.trim());
          subKeys.forEach(k => {
            if (k) {          // only add if not empty
              updates[k] = e;
            }
          });
        }

        console.log(updates,"updatesupdatesupdates")

        const qtySet = e;
        const {
            routes: n
        } = window.MinimogSettings, r = JSON.stringify({
            updates,
            sections: this.getSectionsToRender().map((t => t.section)),
            sections_url: window.location.pathname
        });
        fetch(`${n.cart_update_url}`, {
            ...fetchConfig(),
            body: r
        }).then((t => t.text())).then((e => {
            const i = JSON.parse(e);
            let n = document.getElementById(`MinimogDrawer-quantity-${t}`);
            this.isCartPage && (n = MinimogTheme.config.mqlMobile ? document.querySelector(`.MinimogQuantity-${t}.MinimogQuantity-mobile`) : document.querySelector(`.MinimogQuantity-${t}.MinimogQuantity-desktop`));
            const r = document.querySelectorAll(".m-cart-item");
            if (i.errors) return this.loading.finish(), n.value = n.getAttribute("value"), void this.updateLiveRegions(t, i.errors);
            this.classList.toggle("m-cart--empty", 0 === i.item_count), this.cartDrawerWrapper && this.cartDrawerWrapper.classList.toggle("m-cart--empty", 0 === i.item_count), this.getSectionsToRender().forEach((t => {
            
                (document.getElementById(t.id).querySelectorAll(t.selector) || document.getElementById(t.id)).forEach((item) => {
                    item.innerHTML = this.getSectionInnerHTML(i.sections[t.section], t.selector)
                })
            }));
            const a = i.items[t - 1] ? i.items[t - 1].quantity : void 0;
            let s = "";
            r.length === i.items.length && a !== parseInt(n.value) && (s = void 0 === a ? window.MinimogStrings.cartError : window.MinimogStrings.quantityError.replace("{{ quantity }}", a)), this.updateLiveRegions(t, s), MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {
                ...i,
                source: "main-cart-items"
            })
          syncFreeProduct();
          
          const test = element.getAttribute("data-free-items");
          if (test) {
            const arr = test.split(",").filter(Boolean);
            console.log(arr,qtySet,"arr,qtySetarr,qtySet")
            if (qtySet != 0) {
              updateMultipleQuantitiesByVariantIds(arr,qtySet);
            }
            // updateSubProductsByUniqueId(test, 0); 
          }
          
        })).catch((() => {})).finally((() => {
            this.loading.finish()
        }))
    }
    updateLiveRegions(t, e) {
        let i = document.getElementById(`MinimogCartDrawer-Item-${t}`);
        this.isCartPage && (i = document.getElementById(`MinimogCart-Item-${t}`)), "" !== e && i && MinimogTheme.Notification.show({
            target: i,
            type: "warning",
            message: e
        })
    }
    getSectionInnerHTML(t, e) {
        return (new DOMParser).parseFromString(t, "text/html").querySelector(e).innerHTML
    }
    getSectionsToRender() {
        return [{
            id: "MinimogCart",
            section: "cart-template",
            selector: "[data-minimog-cart-items]"
        }, {
            id: "MinimogCart",
            section: "cart-template",
            selector: "[data-cart-subtotal]"
        }, {
            id: "MinimogCart",
            section: "cart-template",
            selector: "[data-minimog-cart-discounts]"
        }, {
            id: "MinimogCart",
            section: "cart-template",
            selector: "[data-minimog-gift-wrapping]"
        }]
    }
}
customElements.define("m-cart", MCartTemplate);



document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".action-change-variant");
  if (!btn) return;

  const removeKey = btn.dataset.itemRemoveKey;
  const addKey = btn.dataset.itemAddKey; // comma-separated variant IDs
  const sellingPlanId = btn.dataset.itemAddSellingPlan; // comma-separated
  let rawProps = btn.dataset.itemAddProperties; // JSON string (array of property objects)
  const uniqueId = generateUniqueId();

  // Basic validation
  if (!removeKey || !addKey) {
    console.error("Missing required data attributes on button.");
    return;
  }

  btn.classList.add("is-loading");

  const productsToAdd = [];
  const addKeys = addKey.split(",").map(k => k.trim());
  const sellingPlans = sellingPlanId ? sellingPlanId.split(",").map(s => s.trim()) : [];

  // Parse properties (if provided)
  let allProperties = [];
  if (rawProps) {
    try {
      rawProps = rawProps.replace(/'/g, '"'); // Convert single quotes to double quotes
      rawProps = rawProps.replace(/}\s*{/g, '},{'); // Fix missing commas between objects
      allProperties = JSON.parse(rawProps);
      if (!Array.isArray(allProperties)) {
        throw new Error("Parsed properties must be an array");
      }
    } catch (err) {
      console.error("Invalid properties format:", err);
      allProperties = [];
    }
  }

  // Build product objects to add
  addKeys.forEach((id, index) => {
    let productProperties = { "_unique-id": uniqueId };

    if (allProperties[index] && typeof allProperties[index] === "object") {
      productProperties = { ...productProperties, ...allProperties[index] };
    }

    const productObj = {
      id,
      quantity: 1,
      properties: productProperties
    };

    if (sellingPlans[index]) {
      productObj.selling_plan = sellingPlans[index];
    }

    productsToAdd.push(productObj);
  });

  try {
    // Step 1: Remove old variant
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: removeKey, quantity: 0 })
    });

    // Step 2: Add new products
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: productsToAdd })
    });

    // Step 3: Remove orphaned free gifts
    const cart = await fetch("/cart.js").then(res => res.json());
    const itemsToRemove = [];

    cart.items.forEach(item => {
      const price = item.final_line_price / 100;
      const uid = item.properties["_unique-id"];

      if (price === 0 && uid) {
        const hasMainProduct = cart.items.some(otherItem =>
          otherItem.properties["_unique-id"] === uid &&
          otherItem.final_line_price > 0
        );

        if (!hasMainProduct) {
          itemsToRemove.push(item.key);
        }
      }
    });

    if (itemsToRemove.length) {
      const updates = {};
      itemsToRemove.forEach(key => updates[key] = 0);

      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates })
      });
    }

    console.log(cart,"cartcart")
    if (document.querySelector("[name='checkout'] [data-cart-subtotal]")) {
        document.querySelector("[name='checkout'] [data-cart-subtotal]").innerHTML = formatMoney(cart.total_price,window.MinimogSettings.money_format);
    }
    // Step 4: Refresh cart drawer UI
    var cartDrawer = document.querySelector('m-cart-drawer');
    if (cartDrawer) {
        cartDrawer.onCartDrawerUpdate(false);
        if (document.querySelector("m-cart-drawer-items")) {
        document.querySelector("m-cart-drawer-items").loading.finish();
        }
    }else {
        window.location.reload()
    }

  } catch (err) {
    console.error("Error swapping variants:", err);
  } finally {
    btn.classList.remove("is-loading");
  }
});
